module.exports = __webpack_public_path__ + "img/la-quinta-logo.d90fa1c9.png";